// extracted by mini-css-extract-plugin
module.exports = {"blue":"boNo7","green":"_3eG2q","purple":"nIl0E","orange":"_3QdOI","red":"_3pKaj","pink":"pmUdK","yellow":"_2JsiI","sharelov":"_3msF6"};